import React, { useMemo } from 'react';
import { Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../components/common/CrudPage';
import surveyService from '../../services/survey/surveyService';
import { SURVEY_APPROVAL } from '../../constants/survey';
import { getSurveyFormFields } from './surveyFormFields';

const { Text } = Typography;

const SurveyManagement = () => {
  const filterFields = useMemo(() => [
    {
      label: 'Trạng thái',
      value: 'status',
      options: [
        { label: 'Tất cả trạng thái', value: '' },
        { label: 'Đã duyệt', value: SURVEY_APPROVAL.APPROVED.toString() },
        { label: 'Chờ duyệt', value: SURVEY_APPROVAL.PENDING.toString() },
      ],
    },
  ], []);

  const formFields = useMemo(() => getSurveyFormFields(), []);

  const columns = useMemo(() => [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      align: 'center',
    },
    {
      title: 'TIÊU ĐỀ',
      dataIndex: 'title',
      key: 'title',
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'SỐ CÂU HỎI',
      dataIndex: 'questions',
      key: 'questions_count',
      width: 120,
      align: 'center',
      render: (questions) => <Tag color="blue">{questions?.length || 0} câu</Tag>,
    },
    {
      title: 'TRẠNG THÁI',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      align: 'center',
      render: (status) => (
        <Tag color={status === SURVEY_APPROVAL.APPROVED ? 'green' : 'orange'}>
          {status === SURVEY_APPROVAL.APPROVED ? 'ĐÃ DUYỆT' : 'CHỜ DUYỆT'}
        </Tag>
      ),
    },
    {
      title: 'NGÀY TẠO',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 180,
      render: (date) => (date ? dayjs(date).format('DD/MM/YYYY HH:mm') : '-'),
    },
  ], []);

  return (
    <CrudPage
      title="QUẢN LÝ KHẢO SÁT (SURVEY)"
      subTitle="Quản lý danh sách các khảo sát trong hệ thống"
      itemsName="Survey"
      queryKey="surveyList"
      service={surveyService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm tiêu đề..."
      addButtonLabel="Thêm Survey"
      formConfig={{ width: 1200 }}
    />
  );
};

export default SurveyManagement;

